import React, { useState } from "react";
import PropTypes from "prop-types";
import { Flex, Select, Loading } from "orcs-design-system";
import { map, filter } from "lodash";
import { buildOptions } from "src/util/selectUtil";

// Mapping between internal values and display values
const PAGE_TYPE_MAPPING = {
  All: "All",
  People: "People (beta)",
  Teams: "Teams (beta)",
  Tags: "Tags (beta)",
  "Explore Tags": "Explore Tags",
};

// Create display options using the mapping
const EMBED_PAGE_TYPE_OPTIONS = buildOptions(Object.values(PAGE_TYPE_MAPPING));

// Helper function to get internal value from display value
const getInternalValue = (displayValue) => {
  return (
    Object.keys(PAGE_TYPE_MAPPING).find(
      (key) => PAGE_TYPE_MAPPING[key] === displayValue
    ) || displayValue
  );
};

// Helper function to get display value from internal value
const getDisplayValue = (internalValue) => {
  return PAGE_TYPE_MAPPING[internalValue] || internalValue;
};

const EmbedPageTypesSelect = ({ flag, value, onUpdateFeatureFlags }) => {
  const [selected, setSelected] = useState(value || []);
  const [isSaving, setIsSaving] = useState(false);

  const onChange = (selectedOption) => {
    const optionValues = map(selectedOption, (o) => getInternalValue(o.value));

    // Handle "All" selection - if "All" is selected, remove all other options
    if (optionValues.includes("All")) {
      setSelected(["All"]);
      return;
    }

    // Remove "All" if other specific options are selected
    const filteredOptions = optionValues.filter((option) => option !== "All");
    setSelected(filteredOptions);
  };

  const onBlur = async () => {
    setIsSaving(true);
    await onUpdateFeatureFlags(flag, filter(selected, Boolean));
    setIsSaving(false);
  };

  // Convert internal values to display values
  const displayValue = selected.map(getDisplayValue);

  return (
    <Flex alignItems="top" m="r" data-testid={flag}>
      <Select
        isMulti
        label="Select which views / pages you want to enable the embed option"
        inputId="embed-page-types"
        placeholder="Select page types..."
        options={EMBED_PAGE_TYPE_OPTIONS}
        value={buildOptions(displayValue)}
        onChange={onChange}
        onBlur={onBlur}
      />
      {isSaving && <Loading ml="r" />}
    </Flex>
  );
};

EmbedPageTypesSelect.propTypes = {
  flag: PropTypes.string,
  value: PropTypes.array,
  onUpdateFeatureFlags: PropTypes.func,
};

export default EmbedPageTypesSelect;
